






import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { Button } from 'element-ui';

// svg
import LockedIcon from '@/components/svgs/lock.vue';
import UnlockedIcon from '@/components/svgs/unlock.vue';

import { shipmentService } from '@/services/ShipmentService';

@Component({
  components: {
    LockedIcon,
    UnlockedIcon,
    'el-button': Button
  }
})
export default class ShipmentLocked extends Vue {
  @Prop({ required: true, type: String }) public shipmentId!: string;
  @Prop({ default: false, type: Boolean }) public locked!: boolean;

  isLoading = false;

  async toggleLock() {
    try {
      this.isLoading = true;
      const response = await shipmentService.lock({ shipmentId: this.shipmentId, locked: !this.locked });

      if (response.data.lockShipment) {
        this.$emit('update-lock', !this.locked);
      }
    } catch (error) {
      this.$store.dispatch('Alert/addAlert', {
        type: 'error',
        message: this.$t('error.push'),
        time: 2000
      });
    } finally {
      this.isLoading = false;
    }
  }

  get currentIcon() {
    return this.locked ? 'LockedIcon' : 'UnlockedIcon';
  }

  get iconColor() {
    return this.locked ? null : '#4a90e2';
  }
}
